import { render, staticRenderFns } from "./UpdateStorability.vue?vue&type=template&id=1a78158b&"
import script from "./UpdateStorability.vue?vue&type=script&lang=js&"
export * from "./UpdateStorability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports